import { http } from '@/core/http/client'
import { listDictDataByType } from '@/services/system/system'
import type { DictDataRecord } from '@/models/system'

export interface HomeCounts {
  patientCount?: number
  manCount?: number
  womanCount?: number
  hunmanCount?: number
  ivusCount?: number
  nowIvusCount?: number
  clinicalCount?: number
}

export interface QuickEntry {
  id?: string | number
  delFlag?: boolean
  revision?: string
  createdBy?: string
  createdTime?: string
  updatedBy?: string
  updatedTime?: string
  orgId?: string | number
  item?: string
  status?: string
  name?: string
  icon?: string
  url?: string
}

export interface QuickEntryOption {
  label: string
  value: string
}

export interface RecentIvus {
  id?: string | number
  patientId?: string | number
  mNo?: string
  uploadName?: string
  runCount?: number | string
  createdTime?: string
  displayName?: string
  name?: string
  admissionTime?: string
}

export interface DiskSpace extends Record<string, unknown> {
  path?: string
  totalSpace?: number | string
  usedSpace?: number | string
  freeSpace?: number | string
  usedPercent?: number | string
  usableSpace?: number | string
  total?: number | string
  used?: number | string
  free?: number | string
  available?: number | string
}

export function getQuickEntries(params?: { name?: string }) {
  return http.get<QuickEntry[]>('/quickEntry/list', params)
}

export function updateQuickEntries(data: QuickEntry[]) {
  return http.put('/quickEntry', data)
}

function toQuickEntryOptions(items: DictDataRecord[]) {
  return (items || [])
    .map((item) => ({ label: item.dictLabel?.trim() || '', value: item.dictValue?.trim() || '' }))
    .filter((item) => item.label && item.value)
}

export async function getQuickEntryOptions() {
  const [icons, projects] = await Promise.all([listDictDataByType('sys_icon'), listDictDataByType('sys_project')])
  return { icons: toQuickEntryOptions(icons), projects: toQuickEntryOptions(projects) }
}

export function getHomeCounts(params?: unknown) {
  return http.get<HomeCounts>('/quickEntry/getCountsOnHomePage', params)
}

export function getRecentPatients(params?: { name?: string }) {
  return http.get<unknown[]>('/patientInfo/recentList', params)
}

export function getRecentIvus(params?: { name?: string }) {
  return http.get<RecentIvus[]>('/dicom/getDicomHomePage', params)
}

export function getDiskSpace() {
  return http.get<DiskSpace[]>('/dicomStorage/diskSpace')
}
